/* LOT */

export interface GGNotificationLotDTO {
    id?: string
    ggNotificationCOCTabId?: string
    address?: string
    products?: string
    totalQuantity?: number
    manipulationPeriod?: string
    labelling?: boolean
    destinationCountry?: string
}

export interface GetAllGGNotificationLotDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: GGNotificationLotDTO[]
}

export interface GetAllGGNotificationLotFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    ggNotificationCOCTabId?: string
}

/* TAB */

export enum CoCTypeEnum {
    LAVORAZIONE = 'LAVORAZIONE',
    STOCCAGGIO = 'STOCCAGGIO',
    BROKERAGGIO = 'BROKERAGGIO'
}

export enum CoCTabPartialTransformationEnum {
    TAGLIO = 'TAGLIO',
    AFFETTATURA = 'AFFETTATURA',
    CUBETTATURA = 'CUBETTATURA',
    CONGELAMENTO = 'CONGELAMENTO'
}

export interface GGNotificationTabDTO {
    id?: string
    ggNotificationId?: string
    cocTypes: CoCTypeEnum[]
    partialTransformation: boolean
    cocPartialTransformations: CoCTabPartialTransformationEnum[]
    ggnLabelLogoLicense: boolean
    subcontractedActivity: string
}

export interface GetAllGGNotificationTabDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: GGNotificationTabDTO[]
}

export interface GetAllGGNotificationTabFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    ggNotificationId?: string
}